var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
var contentElements = document.querySelectorAll('[data-teaser-content-element]');
contentElements.forEach(function (contentElement) {
    var actionObjects = contentElement.querySelectorAll('[data-teaser-fetch-action]');
    var preloadingObject = contentElement.querySelector('[data-teaser-fetch-preloading]');
    var resultObject = contentElement.querySelector('[data-teaser-fetch-result]');
    actionObjects.forEach(function (actionObject) {
        if (contentElement && actionObject && preloadingObject) {
            var url_1 = actionObject.getAttribute('data-teaser-fetch-url');
            var filterUid_1 = actionObject.getAttribute('data-teaser-fetch-filter');
            var contentElementUid_1 = actionObject.getAttribute('data-teaser-fetch-content-element');
            if (url_1 && filterUid_1 && contentElementUid_1) {
                actionObject.addEventListener('click', function () { return __awaiter(_this, void 0, void 0, function () {
                    var response, _a, error_1;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                _b.trys.push([0, 3, , 4]);
                                return [4 /*yield*/, fetch(url_1, {
                                        method: 'POST',
                                        headers: {
                                            'content-type': 'application/json',
                                        },
                                        body: JSON.stringify({
                                            filterUid: filterUid_1,
                                            contentElementUid: contentElementUid_1,
                                        })
                                    })];
                            case 1:
                                response = _b.sent();
                                preloadingObject.classList.remove('d-none');
                                _a = resultObject;
                                return [4 /*yield*/, response.text()];
                            case 2:
                                _a.innerHTML = _b.sent();
                                preloadingObject.classList.add('d-none');
                                removeAllActiveClasses(actionObjects);
                                actionObject.classList.add('is-active');
                                return [3 /*break*/, 4];
                            case 3:
                                error_1 = _b.sent();
                                throw new Error('An error occurred during the fetch request for the teaser filtering: ' + error_1.message);
                            case 4: return [2 /*return*/];
                        }
                    });
                }); });
            }
        }
        else {
            throw new Error('DOM elements for the filter function of the teaser elements are missing.');
        }
    });
});
/**
 * Removes the class "is-active" from all filter chips of the given DirectEntry element.
 */
function removeAllActiveClasses(actionsObjects) {
    actionsObjects.forEach(function (actionObject) {
        actionObject.classList.remove('is-active');
    });
}
